import { IRouteSetupDetail } from 'src/app/models';

export function initialRouteSetupDetailCreate(setupDetail?: IRouteSetupDetail): IRouteSetupDetail {
  return {
    tag: "",
    client: setupDetail?.client || {},
    config: {
      creationAdvancedDays: 7,
      minutesBeforeReady: 15,
      mobileAppReservationLimit: false,
      mobileAppReservationLimitMinutes: 0,
      mobileAppReservationLimitPreviousDayHour: null,
      mobileAppReservationLimitPreviousDayWorkingDay: false,
      showSetupName: false,
      phoneDrivers: false,
      validateTasks: false,
      rejectTasks: false,
      showUsersPhone: false,
      navigation: false,
      maxReservationTimeApp: 0,
      maxReservationTimeWeb: 0,
      mobileAppCancelReservationLimit: false,
      mobileAppCancelReservationLimitMinutes: 0,
      mobileAppCancelReservationLimitPreviousDayHour: null,
      mobileAppCancelReservationLimitPreviousDayWorkingDay: false,
      driverAppNextExpeditionsDaysLimit: 7,
      driverAppPastExpeditionsDaysLimit: 0,
      tripReassignment: false,
      backgroundTracking: false,
      connections: false,
      showDriverContact: false,
      updateFrequency: 2,
      maxAdvancement: 10,
      minAutoCloseDelayOutsideWindow: 15,
      expeditionDetectionRadius: 300,
      segmentDetectionRadius: 20,
      gtfsId: undefined,
      stickToTheEnd: false,
      rebuildNoShows: false
    },
    daysOfWeek: [],
    holyDays: [],
    holidayCalendars: [],
    name: "Default",
    route: setupDetail?.route || {},
    fromDate: null,
    toDate: null,
    active: false
  };
}

export const routeSetupDetailConfigData = [
    'creationAdvancedDays',
    'minutesBeforeReady',
    'mobileAppReservationLimit',
    'mobileAppReservationLimitMinutes',
    'mobileAppReservationLimitPreviousDayHour',
    'mobileAppReservationLimitPreviousDayWorkingDay',
    'showSetupName',
    'phoneDrivers',
    'validateTasks',
    'rejectTasks',
    'showUsersPhone',
    'navigation',
    'maxReservationTimeApp',
    'maxReservationTimeWeb',
    'mobileAppCancelReservationLimit',
    'mobileAppCancelReservationLimitMinutes',
    'mobileAppCancelReservationLimitPreviousDayHour',
    'mobileAppCancelReservationLimitPreviousDayWorkingDay',
    'driverAppNextExpeditionsDaysLimit',
    'driverAppPastExpeditionsDaysLimit',
    'tripReassignment',
    'backgroundTracking',
    'connections',
    'showDriverContact',
    'updateFrequency',
    'maxAdvancement',
    'minAutoCloseDelayOutsideWindow',
    'expeditionDetectionRadius',
    'segmentDetectionRadius',
    'gtfsId',
    'stickToTheEnd',
    'rebuildNoShows',
  ];

  export const routeSetupDetailLocalTimeData = [
    'mobileAppReservationLimitPreviousDayHour',
    'mobileAppCancelReservationLimitPreviousDayHour',
  ];

export const routeSetupToggleDependentFields: Record<string, string[]> = {
  mobileAppReservationLimit: [
    'mobileAppReservationLimitMinutes',
    'mobileAppReservationLimitPreviousDayHour',
    'mobileAppReservationLimitPreviousDayWorkingDay',
  ],
  mobileAppCancelReservationLimit: [
    'mobileAppCancelReservationLimitMinutes',
    'mobileAppCancelReservationLimitPreviousDayHour',
    'mobileAppCancelReservationLimitPreviousDayWorkingDay',
  ],
  backgroundTracking: [
    'minAutoCloseDelayOutsideWindow',
    'expeditionDetectionRadius',
    'segmentDetectionRadius',
  ],
};

export function clearDisabledToggleDependents<T extends Record<string, any>>(config: T): T {
  const cleaned: Record<string, any> = { ...config };
  Object.entries(routeSetupToggleDependentFields).forEach(([toggle, dependents]) => {
    if (cleaned[toggle] === false) {
      dependents.forEach(field => cleaned[field] = null);
    }
  });
  return cleaned as T;
}

export function initialPartialRouteSetupConfig(): any {
  return {
    fromDate: null,
    toDate: null,
    config: {
      creationAdvancedDays: null,
      minutesBeforeReady: null,
      mobileAppReservationLimit: null,
      mobileAppReservationLimitMinutes: null,
      mobileAppReservationLimitPreviousDayHour: null,
      mobileAppReservationLimitPreviousDayWorkingDay: null,
      showSetupName: null,
      phoneDrivers: null,
      validateTasks: null,
      rejectTasks: null,
      showUsersPhone: null,
      navigation: null,
      maxReservationTimeApp: null,
      maxReservationTimeWeb: null,
      mobileAppCancelReservationLimit: null,
      mobileAppCancelReservationLimitMinutes: null,
      mobileAppCancelReservationLimitPreviousDayHour: null,
      mobileAppCancelReservationLimitPreviousDayWorkingDay: null,
      driverAppNextExpeditionsDaysLimit: null,
      driverAppPastExpeditionsDaysLimit: null,
      tripReassignment: null,
      backgroundTracking: null,
      connections: null,
      showDriverContact: null,
      updateFrequency: null,
      maxAdvancement: null,
      minAutoCloseDelayOutsideWindow: null,
      expeditionDetectionRadius: null,
      segmentDetectionRadius: null,
      gtfsId: null,
      stickToTheEnd: null,
      rebuildNoShows: null
    }
  };
}
